module.exports = __webpack_public_path__ + "img/id.f281e691.svg";